import { trimAll } from '../util';
// 是否是身份证
export const isIdNo = (value) => {
    return /^\d{17}[0-9xX]/.test(trimAll(value));
};
// 是否是银行卡号
export const isCardNo = (value) => {
    return /^\d{15,21}$/.test(trimAll(value));
};
// 是否手机号码
export const isPhoneNo = (value) => {
    return /^1\d{10}$/.test(trimAll(value));
};
// 是否固定电话或者手机号，支持 10086 或者 手机号
export const isTelephone = (value) => {
    return /^(0\d{2,3}-?)?\d{5,11}$/.test(trimAll(value));
};
// 是否是短信验证码，默认6位，支持范围设定
export const isSmsCode = (value, range = 6) => {
    if (typeof range === 'number') {
        return new RegExp(`^\\d{${range}}$`).test(trimAll(value));
    }
    return new RegExp(`^\\d{${range[0]},${range[1]}}$`).test(trimAll(value));
};
// 是否给定范围的汉字内容
export const isChinese = (min = 0, max = '') => {
    return (value) => {
        return new RegExp(`^[\\u4e00-\\u9fa5]{${min},${max}}$`).test(trimAll(value));
    };
};
// 是否给定范围的汉字且允许包含特定的字符
export const isChineseWith = (withReg, min = 0, max = '') => {
    return (value) => {
        return new RegExp(`^[\\u4e00-\\u9fa5]{${min},${max}}$`).test(trimAll(value).replace(withReg, ''));
    };
};
// 邮箱地址
export const isEmail = (value) => {
    return /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(trimAll(value));
};
// 判断是否是闰年
export const isLeapYear = (year) => {
    if ((Number(year) % 4 === 0 && Number(year) % 100 !== 0) && Number(year) % 400 === 0) {
        return true;
    }
    return false;
};
// 判断是否成年 年满18岁
export const isAdult = (idNo) => {
    const id = idNo.replace(/\s/g, '');
    const now = new Date();
    const nowYear = now.getFullYear();
    const nowMonth = now.getMonth() + 1;
    let nowDate = now.getDate();
    if (nowMonth === 2 && nowDate > 28) {
        nowDate = isLeapYear(nowYear - 18) ? 29 : 28;
    }
    const nowTime = Date.parse(`${nowYear - 18}/${nowMonth}/${nowDate}`);
    const birthTime = Date.parse(id.substring(6, 14).replace(/(\d{4})(\d{2})(\d{2})/g, '$1/$2/$3'));
    return nowTime >= birthTime;
};
export default {
    isIdNo,
    isCardNo,
    isPhoneNo,
    isTelephone,
    isSmsCode,
    isChinese,
    isChineseWith,
    isEmail,
    isLeapYear,
    isAdult
};
//# sourceMappingURL=index.js.map